import styled from "styled-components";

export const CardSelectionViewContainer = styled.div`
    align-items: center;
    display: flex;
    height: 600px;
    justify-content: center;
    position: relative;
    width: 100%;
`

export const CenteredCard = styled.div`
    position: relative;
    width: 100%;
`

export const BelowCard = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
    width: 100%;
`

export const EditorActionRow = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    width: 100%;
`

export const EditorField = styled.div`
    align-items: stretch;
    display: inline-flex;
    flex-direction: column;
    gap: 8px;

    & > * {
        width: 100%;
    }
`

export const ReplacementWarningText = styled.p`
    color: #ff6b6b;
    font-size: 14px;
    line-height: 1.35;
    max-width: 360px;
    text-align: center;
    width: 100%;
`;